
<script>
import { onMounted} from 'vue'
  import PageHeader from "../../layout/PageHeader.vue";
  import $ from "jquery";

export default {
    name: "PageSearch",
    components:{
      PageHeader
    },
    setup(){

      function updateDataLayer(){

        $(document).ready(function () {
          window.dataLayer = window.dataLayer || [];

          // Default values
          var searchPage = 0;
          var itemToPush = {};
          itemToPush['search_category'] = 'Principal';
          itemToPush['search_result'] = 'Sans résultat';
          itemToPush['pagetype'] = 'Recherche';

          // Page title (pagename)
          var H1 = jQuery('h1');
          if (H1.length) {
            itemToPush['pagename'] = H1.text().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          } else if (window.location.pathname === "/"){
            itemToPush['pagename'] = "Accueil"
          }

          // Get keyword from url parameter
          var keyword = getUrlParameter('keys');
          if(keyword){
            itemToPush['keyword'] = keyword.replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            // Check if there are results
            if($('.search-results').length){
              itemToPush['search_result'] = 'Avec résultat';
              // Check page number
              var page = getUrlParameter('page');
              if(!page){
                // Première page des résultats, pas de paramètre dans l'url
                searchPage = 1;
              }else{
                // On adapte le numéro pour commencer par 1 et non 0
                searchPage = parseInt(page) + 1;
              }
            }
          }

          itemToPush['search_page'] = searchPage;
          itemToPush['event'] = "page_load";
          window.dataLayer.push(itemToPush);

          // Push click events
          $('.search-results .search__result > a').on('click', function(e){
            var resultitem = $(this).closest('li');
            var resultItemPosition = parseInt($('.search-results li').index(resultitem)) + 1;

            window.dataLayer.push({
              'event': 'click_internal_search',
              'keyword': keyword.replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
              'search_rank': resultItemPosition,
              'search_page': searchPage,
              'search_category': 'Principal',
              'search_type': 'Page de résultat'
            })
          });

        });
      };
      function getUrlParameter(key){
        var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === key) {
            return decodeURIComponent(sParameterName[1]);
          }
        }
        return false;
      };
      function removeAutoAddedClass(){
        let form = document.getElementsByClassName("search-api-page-block-form-custom-search-page");
        form[0].classList.remove("container-inline");
      };
      function updateAutoCompleteFieldStyles(){
          const searchInput = document.querySelector('.form-autocomplete');
          const formDiv = document.querySelector('.js-form-type-search');

          let autocompleteSearchInput = searchInput.cloneNode(true);

          //'form-autocomplete', 'form-text', ' ui-autocomplete-input'
          autocompleteSearchInput.classList.add('form-search');
          autocompleteSearchInput.setAttribute('type', 'search');

          //section div
          let outerDiv = document.createElement('div');
          outerDiv.classList.add('section', 'section--solid', 'section--collapse');

          // Create the inner div with class "container"
          let containerDiv = document.createElement('div');
          containerDiv.classList.add('container');

          // Create the nested div with classes "row center-xs"
          let rowDiv = document.createElement('div');
          rowDiv.classList.add('row', 'center-xs');

          // Create the nested div with class "col-md-6"
          let colDiv = document.createElement('div');
          colDiv.classList.add('col-md-6');
          colDiv.style.width = '100%';

          // Create the nested small element
          let small = document.createElement('small');
          small.innerHTML = "Exemple de recherche : ”bouteille de gaz”, ”je déménage”, ”facture”, etc…"

          // Append the nested divs to each other as needed
          colDiv.appendChild(autocompleteSearchInput)
          colDiv.appendChild(small)
          rowDiv.appendChild(colDiv);
          containerDiv.appendChild(rowDiv);
          outerDiv.appendChild(containerDiv);

          searchInput.replaceWith(outerDiv)

      }
      onMounted(() => {
        updateDataLayer();
        removeAutoAddedClass();
        updateAutoCompleteFieldStyles();
        if(document.getElementsByClassName("menu-disclaimer").length > 0) {
          if(window.innerWidth < 960) {
            document.getElementsByClassName("layout-content")[0].setAttribute("class","layout-content-disclaimer")
          }
        }
      })

      return  { updateAutoCompleteFieldStyles, removeAutoAddedClass, getUrlParameter, updateDataLayer }
}
}
</script>
<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .search
        ol
            padding: 0
        li
            list-style-type: none
        #block-antargaz-content
            h2
                display: none

        .container
            +media('<small')
                padding: 0 1rem
                width: calc(100% - 2rem)


    .search-form
        margin-bottom: $baseline*2

        label
            display: none

        input[type='search']
            width: 100%
            border: none
            background-color: white
            box-shadow: $card-shadow
            padding: $baseline*.75
            font-size: 1.125rem
            line-height: 1

            +media('>=small')
                padding: $baseline $baseline*2

            &::placeholder
                font-size: .875rem

            + small
                display: block
                margin-top: $baseline
                font-size: .75rem


        input[type='submit']
            position: absolute
            top: -9.8rem
            right: calc(45% - 19rem)
            background: transparent url(../../common/assets/icon-search.svg) no-repeat calc(100% - #{$baseline})  / $baseline $baseline*2
            font-size: 0
            padding: $baseline
            box-sizing: border-box
            border: none
            transition: background-color 450ms cubic-bezier(0, 0, 0.2, 1)
            +media('<1600px')
              right: calc(47% - 13rem)
            +media('<1024px')
              top: -10.6rem
              right: calc(47% - 10rem)
            +media('<960px')
              top: -7.4rem
              right: calc(46% - 11rem)
            +media('<890px')
              top: -7.4rem
            +media('<427px')
              top: -8.2rem
            +media('<360px')
              right: calc(54% - 11rem)

        // button
        //     margin-left: .5rem
        //     padding: .375rem
        //     border: none
        //     background: $color-accent
        //     line-height: 0
        //     cursor: pointer
        //     display: inline-block
            // svg
            //     height: $baseline*2
            //     width: $baseline*2


        .form-wrapper
            position: relative

            div
                display: block
            .row
                display: flex

        .search-advanced,
        .search-help-link
            display: none

    .search
        &__result
            position: relative
            margin-bottom: $baseline*1.5
            padding: 0 0 $baseline*1.5
            border-bottom: 1px solid $color-border

            & + &
                margin-top: $baseline*2

            a
                color: inherit
                text-decoration: none

                .title
                    margin-bottom: $baseline*.5

                .text
                    margin-bottom: $baseline

            &__link
                text-decoration: underline

    .page-search

        .page__header__title
            padding-bottom: $baseline

        .form-wrapper
            margin-bottom: $baseline*4

        &__title
            margin-bottom: 1rem!important

        &__subtitle
            margin-bottom: 4rem!important

        &__number
            font-size: 1.8rem
            font-weight: 800
            margin-bottom: 2rem



        //Search bar


        .container-inline.js-form-wrapper.form-wrapper
            .js-form-item.form-item.js-form-type-search.form-item-keys.js-form-item-keys
                position: relative
                &:before
                    content: ''
                    display: block
                    position: absolute
                    width: 2rem
                    height: 2rem
                    background-size: contain
                    background-position: center
                    background-repeat: no-repeat
                    vertical-align: middle
                    right: 1rem
                    top: calc(50% - 1rem)

                input:focus
                    outline-style: none


    //Search autocomplet
    ul[data-sa-theme="minimal"]
        //display: block !important
        width: 44rem !important
        background: #d02a4c !important
        left: auto!important
        right: 0
        border: 0
        padding: 1rem
        top: 8rem!important
        //transition: top 1s ease-out

    .ui-state-disabled, .ui-widget-content .ui-state-disabled, .ui-widget-header .ui-state-disabled
        display: none
    .ui-widget-content a
        color: white
        font-size: 1rem
        padding: 0!important
        margin: 0!important
    .ui-menu .ui-menu-item
        padding: 0!important
        margin: 0!important
    .ui-state-focus
        cursor: pointer!important
        background: none!important
        border: 0!important
        padding: 0!important
        margin: 0!important
    .ui-autocomplete-field-created
        display: none

    .search_api_result
      margin-left: 7%
      margin-right: 7%

</style>
